import { Button, Divider, Modal } from "@mantine/core";
import React, { useRef } from "react";
import { sectorApi } from "../../apis";
import { ISector } from "../../interfaces/ISector";
import { PageLayout } from "../layout";
import { ColumnType, ITableRef, Table } from "../table";
import { Tag } from "../tags";
import RenderText from "../ui/render-text";
import { SectorForm } from "./form";

export function SectorList() {
  const ref = useRef<ITableRef>(null);
  const breadcrumb = useBreadcrumb();
  const [action, setAction] = React.useState<string[]>([]);

  const columns = useHeader();

  const onCancel = () => {
    setAction([]);
  };

  const reload = () => {
    ref.current?.reload();
  };

  return (
    <>
      <PageLayout
        title="Сектор жагсаалт"
        subTitle="Үндсэн ангилал дотроос задрах эдийн засгийн сектор"
        breadcrumb={breadcrumb}
        extra={[
          <Button onClick={() => setAction(["SECTOR"])} key={1}>
            Нэмэх
          </Button>,
        ]}>
        <Divider mb={5} />
        <Table
          ref={ref}
          name="partner-management-user-sector-data.list"
          columns={columns}
          filters={{ level: "2", query: "" }}
          loadData={(data) => sectorApi.list(data!)}
        />
      </PageLayout>
      <Modal opened={action[0] === "SECTOR"} onClose={() => onCancel()} withCloseButton={false} size="lg" centered>
        <SectorForm reload={reload} onCancel={onCancel} />
      </Modal>
    </>
  );
}

const useHeader = (): ColumnType<ISector>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Үндсэн ангилал",
    sorter: true,
    dataIndex: "name",
    render: (record) => <RenderText text={record?.parent?.name ?? "-"} />,
  },
  {
    title: "Нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => <RenderText text={record?.name ?? "-"} />,
  },
  {
    title: "Код",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => <RenderText text={record?.refCode ?? "-"} />,
  },
  {
    title: "Нээлттэй",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => <Tag name={record.isPublic ? "Тийм" : "Үгүй"} color={record.isPublic ? "green.5" : "red.5"} />,
  },
];

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Эхлэл",
  },
  {
    label: "Секторын лавлах жагсаалт",
    to: "/partner-management/sector",
  },
  {
    label: "Секторын жагсаалт",
  },
];
